import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as $ from 'jquery';
import { NotificationWindowService } from './notification-window.service';
import { MessageService } from './message.service';
import 'signalR';
import { PriceManagementDataService } from '../price-management/price-management-data.service';
import { AuthenticationService } from '../core/authentication/shared/authentication.service';
import { Observable, Subject } from 'rxjs';
import { AppConfig } from '../app.config';

declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private config = AppConfig.settings;

  priceManagementHub;
  signalRInitialized:boolean = false;
  isLoggingOff:boolean = false;

  scheduleChange$: Observable<any>;
  private _scheduleChangeSubject = new Subject<any>();
  
  constructor(
    private _authenticationService: AuthenticationService,
    private _notificationWindowService: NotificationWindowService,
    private _priceManagementDataService: PriceManagementDataService,
    private _messageService: MessageService,
  ) {
    this.scheduleChange$ = this._scheduleChangeSubject.asObservable();
  }

  setScheduleChange(){
    this._scheduleChangeSubject.next(true);
  }

  loadSignalRHubs() {
    var self = this;
    this.signalRInitialized = false;
    //Load SignalR
    $.getScript(AppConfig.settings.baseUrl + '/signalr/hubs')
      .done(function () {
        if (self.config.logSignalR) console.log('Loaded signalR hubs');
        self._notificationWindowService.setAreHubsLoaded(true);
        self.initSignalR();
      })
      .fail(function () {
        console.log('failed to load signalR hubs')
      });
  }

  initSignalR(){
    var self = this;
    
    // Reference the auto-generated proxy for the hub
    this.priceManagementHub = $.connection.priceManagement;

    this.priceManagementHub.client.userConnected = function (userInfo) {
      //if (self.config.logSignalR) console.log('userConnected: ' + userInfo.user.userName);
      self.getReachableConnectedUsers(
        function(data) {
          self._notificationWindowService.setReachableUsers(data);
        },
        function (response) {
          self._messageService.onFailure('Failed to get reachable users.', response);
        });
    };

    this.priceManagementHub.client.userDisconnected = function (userInfo) {
      //if (self.config.logSignalR) console.log('userDisconnected: ' + userInfo.user.userName);
      self.getReachableConnectedUsers(
        function(data) {
          self._notificationWindowService.setReachableUsers(data);
        },
        function (response) {
          self._messageService.onFailure('Failed to get reachable users.', response);
        });
    };

    this.priceManagementHub.client.userReconnected = function (userInfo) {
      //if (self.config.logSignalR) console.log('userReconnected: ' + userInfo.user.userName);
      self.getReachableConnectedUsers(
        function(data) {
          self._notificationWindowService.setReachableUsers(data);
        },
        function (response) {
          self._messageService.onFailure('Failed to get reachable users.', response);
        });
    };

    this.priceManagementHub.client.systemNotification = function (data) {
      if (self.config.logSignalR) console.log({systemNotification: data});
      self._notificationWindowService.createSystemNotification(data);
      //self.getReachableConnectedUsers();
    };

    this.priceManagementHub.client.userNotification = function (data) {
      if (self.config.logSignalR) console.log({userNotification: data});
      self._notificationWindowService.createUserNotification(data);
    };

    this.priceManagementHub.client.userWorkingInStore = function (userInfo) {
      //if (self.config.logSignalR) console.log({userWorkingInStore: userInfo});
      var myUser = JSON.parse(sessionStorage.getItem('rpmsUser')); //trying to get this from authenticationService caused circular dependency
      if (userInfo.user.userId != myUser.userId) {
        self._notificationWindowService.createUserWorkingInStoreNotification(userInfo);
      }
      // TODO?
      // if (userInfo.user.userId != self.myUser.userId) {
      //   self._notificationWindowService.createUserWorkingInStoreNotification(userInfo);
      // }
      // else {
      //   self.myUserWorkingInStore = self.cloneObject(userInfo);
      // }
      self.getReachableConnectedUsers(
        function(data) {
          self._notificationWindowService.setReachableUsers(data);
        },
        function (response) {
          self._messageService.onFailure('Failed to get reachable users.', response);
        });
    };

    this.priceManagementHub.client.userExitedStore = function (userInfo, store) {
      //if (self.config.logSignalR) console.log({userExitedStore: userInfo});
      self._notificationWindowService.createUserExitedStoreNotification(userInfo, store);
      self.getReachableConnectedUsers(
        function(data) {
          self._notificationWindowService.setReachableUsers(data);
        },
        function (response) {
          self._messageService.onFailure('Failed to get reachable users.', response);
        });
    };

    this.priceManagementHub.client.storeItemPriceChanged = function (user, storeItem) {
      //if (self.config.logSignalR) console.log({storeItemPriceChanged: storeItem});
      self._notificationWindowService.createItemUpdateNotification(user, storeItem);
      self._priceManagementDataService.setSignalRStoreItemUpdate(storeItem);
    };

    this.priceManagementHub.client.storeItemTprTagUpdated = function (user, data) {
      //if (self.config.logSignalR) console.log({storeItemTprTagUpdated: data});
      self._notificationWindowService.createStoreItemTprTagUpdatedNotification(user, data);
      self._priceManagementDataService.setSignalRStoreItemUpdate(data);
    };

    this.priceManagementHub.client.storeItemShelfTagUpdated = function (user, data) {
      //if (self.config.logSignalR) console.log({storeItemShelfTagUpdated: data});
      self._notificationWindowService.createStoreItemShelfTagUpdatedNotification(user, data);
      self._priceManagementDataService.setSignalRStoreItemUpdate(data);
    };

    this.priceManagementHub.client.storeItemDeleted = function (user, storeItem) {
      //if (self.config.logSignalR) console.log({storeItemDeleted: storeItem});
      self._notificationWindowService.createItemUpdateNotification(user, storeItem);
      self._priceManagementDataService.setSignalRStoreItemUpdate(storeItem);
    };

    this.priceManagementHub.client.previewStoreItemPriceChanged = function (user, previewStoreItem) {
      //if (self.config.logSignalR) console.log({previewStoreItemPriceChanged: previewStoreItem});
      self._notificationWindowService.createItemUpdateNotification(user, previewStoreItem);
      self._priceManagementDataService.setSignalRStoreItemUpdate(previewStoreItem);
    };

    this.priceManagementHub.client.previewStoreItemPriceChangesEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({previewStoreItemPriceChangesEnabledStateChange: data});
      self._notificationWindowService.createPreviewStoreItemPriceChangesEnabledStateChangeNotification(data);
      self._priceManagementDataService.setPreviewStoreItemPriceChangesEnabledForStoreObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    // this.priceManagementHub.client.meatAndProducePreviewStoreItemPriceChangesEnabledStateChange = function (data) {
    //   if (self.config.logSignalR) console.log({meatAndProducePreviewStoreItemPriceChangesEnabledStateChange: data});
    //   self._notificationWindowService.createMeatAndProducePreviewStoreItemPriceChangesEnabledStateChangeNotification(data);
    //   self._priceManagementDataService.setMeatAndProducePreviewStoreItemPriceChangesEnabledForStoreObject(data);
    //   self._messageService.showToastBottomLeft(data.reason);
    //   self.setScheduleChange();
    // };

    this.priceManagementHub.client.meatPreviewStoreItemPriceChangesEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({meatPreviewStoreItemPriceChangesEnabledStateChange: data});
      self._notificationWindowService.createMeatPreviewStoreItemPriceChangesEnabledStateChangeNotification(data);
      self._priceManagementDataService.setMeatPreviewStoreItemPriceChangesEnabledForStoreObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.producePreviewStoreItemPriceChangesEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({producePreviewStoreItemPriceChangesEnabledStateChange: data});
      self._notificationWindowService.createProducePreviewStoreItemPriceChangesEnabledStateChangeNotification(data);
      self._priceManagementDataService.setProducePreviewStoreItemPriceChangesEnabledForStoreObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.storeItemPriceChangesEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({storeItemPriceChangesEnabledStateChange: data});
      self._notificationWindowService.createStoreItemPriceChangesEnabledStateChangeNotification(data);
      self._priceManagementDataService.setStoreItemPriceChangesEnabledForStoreObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    // this.priceManagementHub.client.meatAndProduceStoreItemPriceChangesEnabledStateChange = function (data) {
    //   if (self.config.logSignalR) console.log({meatAndProduceStoreItemPriceChangesEnabledStateChange: data});
    //   self._notificationWindowService.createMeatAndProduceStoreItemPriceChangesEnabledStateChangeNotification(data);
    //   self._priceManagementDataService.setMeatAndProduceStoreItemPriceChangesEnabledForStoreObject(data);
    //   self._messageService.showToastBottomLeft(data.reason);
    //   self.setScheduleChange();
    // };

    this.priceManagementHub.client.meatStoreItemPriceChangesEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({meatStoreItemPriceChangesEnabledStateChange: data});
      self._notificationWindowService.createMeatStoreItemPriceChangesEnabledStateChangeNotification(data);
      self._priceManagementDataService.setMeatStoreItemPriceChangesEnabledForStoreObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.produceStoreItemPriceChangesEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({produceStoreItemPriceChangesEnabledStateChange: data});
      self._notificationWindowService.createProduceStoreItemPriceChangesEnabledStateChangeNotification(data);
      self._priceManagementDataService.setProduceStoreItemPriceChangesEnabledForStoreObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.serverMaintenanceEnabledStateChange = function (data) {
      if (self.config.logSignalR) console.log({serverMaintenanceEnabledStateChange: data});
      self._notificationWindowService.createServerMaintenanceEnabledStateChangeNotification(data);
      self._priceManagementDataService.setServerMaintenanceEnabledStateChangeObject(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.deletingMeatAndProducePreviewStoreItems = function (data) {
      if (self.config.logSignalR) console.log({deletingMeatAndProducePreviewStoreItems: data});
      self._notificationWindowService.createSystemMessageNotification(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.incrementingWeeksInStore = function (data) {
      if (self.config.logSignalR) console.log({incrementingWeeksInStore: data});
      self._notificationWindowService.createSystemMessageNotification(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.purgingOldLogActions = function (data) {
      if (self.config.logSignalR) console.log({purgingOldLogActions: data});
      self._notificationWindowService.createSystemMessageNotification(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.purgingOldMessages = function (data) {
      //if (self.config.logSignalR) console.log(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.purgingOldAdItems = function (data) {
      //if (self.config.logSignalR) console.log(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.purgingOldStoreItemPriceChanges = function (data) {
      //if (self.config.logSignalR) console.log(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.purgingOldStoreItemCostChanges = function (data) {
      //if (self.config.logSignalR) console.log(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.purgingOldDenormalizedPreviewStoreItemPriceChanges = function (data) {
      //if (self.config.logSignalR) console.log(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };
  
    this.priceManagementHub.client.processingPricingRules = function (data) {
      //if (self.config.logSignalR) console.log(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.resettingMovementAndWeeksInStore = function (data) {
      if (self.config.logSignalR) console.log({resettingMovementAndWeeksInStore: data});
      self._notificationWindowService.createSystemMessageNotification(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.updatingStoreItemsFromMeatAndProducePreviewStoreItems = function (data) {
      if (self.config.logSignalR) console.log({updatingStoreItemsFromMeatAndProducePreviewStoreItems: data});
      //self.dataExpirationDate = data.date;
      self._notificationWindowService.createSystemMessageNotification(data);
      //commented this out 1-14-2020 when I realized it was not being used
      //self._priceManagementDataService.setSignalRDataExpirationDate(data.date);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.updatingStoreItemsFromPreviewStoreItems = function (data) {
      if (self.config.logSignalR) console.log({updatingStoreItemsFromPreviewStoreItems: data});
      self._notificationWindowService.createSystemMessageNotification(data);
      self._messageService.showToastBottomLeft(data.reason);
      self.setScheduleChange();
    };

    this.priceManagementHub.client.scheduleEvent = function (event, reason) {
      if (self.config.logSignalR) console.log({scheduleEvent: event});
      self._messageService.showToastBottomLeft(reason);
      self.setScheduleChange();
    };


    //THE FOLLOWING CODE MUST GO BELOW THE CODE ABOVE IT!!!!!

    // Optionally turn on client side logging
    $.connection.hub.logging = true;

    // Set the connection URL
    $.connection.hub.url = AppConfig.settings.baseUrl + '/signalr';

    // Append the bearer token to the query string
    var token = sessionStorage.getItem('rpmsToken');
    //var token = this._authenticationService.getToken();

    $.connection.hub.qs = { 'access_token': token };

    // Optionally wire up an error handler
    $.connection.hub.error(function (error) {
      console.log('SignalR error: ' + error);
    });

    var tryingToReconnect = false;
    var counter = 1;

    $.connection.hub.connectionSlow(function () {
      console.log("SignalR connection is slow.");
    });

    $.connection.hub.reconnecting(function () {
      tryingToReconnect = true;
      console.log("Trying to reconnect to SignalR.");
    });

    $.connection.hub.reconnected(function () {
      tryingToReconnect = false;
      console.log("SignalR has reconnected.");
    });

    $.connection.hub.disconnected(function () {
      if (!self.isLoggingOff){
        console.log(counter);
        if (tryingToReconnect) {
          console.log("Could not connect to SignalR.");
        }
        if (counter <= 24) {
          setTimeout(function () {
            $.connection.hub.start().done(function () {
              console.log("SignalR hub has started again.");
              self.signalRInitialized = true;
              if (self._authenticationService.isUserLoggedIn){
                self.getReachableConnectedUsers(
                  function(data) {
                    self._notificationWindowService.setReachableUsers(data);
                  },
                  function (response) {
                    self._messageService.onFailure('Failed to get reachable users.', response);
                  });
                }
              });
          }, 5000);
          counter++;
        }
        else {
          self._messageService.alert("Could not connect to the server. Please close the browser window and try to log back in to continue using the application.");
        }
      }
    });

    // Start the connection
    $.connection.hub.start().done(function () {
      if (self.config.logSignalR) console.log('SignalR hub has started.');
      self.signalRInitialized = true;
      if (self._authenticationService.isUserLoggedIn){
        self.getReachableConnectedUsers(
          function(data) {
            self._notificationWindowService.setReachableUsers(data);
          },
          function (response) {
            self._messageService.onFailure('Failed to get reachable users.', response);
          });
      }
    });

  }

  logOff(onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.exitStore()
        .done(function (data) {
          if (self.config.logSignalR) console.log('SignalR exit store was successful');
          self.isLoggingOff = true;
          $.connection.hub.stop();
					console.log('SignalR hub was stopped.');
          if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
        })
        .fail(function (error) {
          console.log('SignalR send error: ' + error);
          if(typeof onFailureCallback === 'function') onFailureCallback(error);
        });
    }
  }

  exitStore(onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.exitStore()
        .done(function (data) {
          if (self.config.logSignalR) console.log('SignalR exit store was successful');
          if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
        })
        .fail(function (error) {
          console.log('SignalR send error: ' + error);
          if(typeof onFailureCallback === 'function') onFailureCallback(error);
        });
    }
  }

  workInStore(storeId, onSuccessCallback?, onFailureCallback?){
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.workInStore(storeId)
      .done(function (data) {
        if (self.config.logSignalR) console.log('SignalR work in store was successful');
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      })
      .fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  }

  getReachableConnectedUsers(onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.getReachableConnectedUsers()
      .done(function (data) {
        if (self.config.logSignalR) console.log('SignalR getReachableConnectedUsers was successful');
        //console.log(data);
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      }).fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  }

  synchronizeMessages(onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.synchronizeMessages()
      .done(function (data) {
        if (self.config.logSignalR) console.log('SignalR synchronizeMessages was successful.');
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      }).fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  } 

  synchronizeStoreItems(timeStamp, onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.synchronizeStoreItems(timeStamp)
      .done(function (data) {
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      }).fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  } 

  synchronizePreviewStoreItems(timeStamp, onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.synchronizePreviewStoreItems(timeStamp)
      .done(function (data) {
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      }).fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  }

  synchronizePreviewStoreItemsV2(timeStamp, onSuccessCallback?, onFailureCallback?) {
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.synchronizePreviewStoreItemsV2(timeStamp)
      .done(function (data) {
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      }).fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  } 

  sendMessageWithinStore(id, message, bool, onSuccessCallback?, onFailureCallback?){
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.sendMessageWithinStore(id, message, bool)
      .done(function (data) {
        if (self.config.logSignalR) console.log('SignalR sendMessageWithinStore was successful.');
        if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
      }).fail(function (error) {
        console.log('SignalR send error: ' + error);
        if(typeof onFailureCallback === 'function') onFailureCallback(error);
      });
    }
  }

  sendMessageWithinStoreGroup(id, message, bool, onSuccessCallback?, onFailureCallback?){
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.sendMessageWithinStoreGroup(id, message, bool)
        .done(function (data) {
          if (self.config.logSignalR) console.log('SignalR sendMessageWithinStore was successful.');
          if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
        }).fail(function (error) {
          console.log('SignalR send error: ' + error);
          if(typeof onFailureCallback === 'function') onFailureCallback(error);
        });
    }
  }
  
  sendMessageToUser(id, message, bool, onSuccessCallback?, onFailureCallback?){
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.sendMessageToUser(id, message, bool)
        .done(function (data) {
          if (self.config.logSignalR) console.log('SignalR sendMessageWithinStore was successful.');
          if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
        }).fail(function (error) {
          console.log('SignalR send error: ' + error);
          if(typeof onFailureCallback === 'function') onFailureCallback(error);
        });
    }
  }

  sendAdminMessage(message, onSuccessCallback?, onFailureCallback?){
    var self = this;
    if (self.signalRInitialized){
      this.priceManagementHub.server.sendAdminMessage(message)
        .done(function (data) {
          if (self.config.logSignalR) console.log('SignalR sendMessageWithinStore was successful.');
          if(typeof onSuccessCallback === 'function') onSuccessCallback(data);
        }).fail(function (error) {
          console.log('SignalR send error: ' + error);
          if(typeof onFailureCallback === 'function') onFailureCallback(error);
        });
    }
  }
  
}
